/*
	Generated on 10/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.10.0
*/
import React, { useEffect, useState, useContext} from 'react'
import { Button, Spinner } from "@/commons/components"
import * as Layouts from '@/commons/layouts';
import { Link } from "react-router";
import { useParams } from "@/commons/hooks/useParams"
import { HeaderContext } from "@/commons/components"
import { useNavigate } from "react-router";
import { useAuth } from '@/commons/auth';
import RuanganTable from "../components/RuanganTable";

import getRuanganDataList from '../services/getRuanganDataList'
const DaftarRuanganPage = props => {
const { checkPermission } = useAuth();

	const [isLoading, setIsLoading] = useState({
	daftarRuangan: false,

	});
	const { setTitle } = useContext(HeaderContext);

const [ruanganDataList, setRuanganDataList] = useState()
	
	
	

	useEffect(() => {
		

		const fetchData = async () => {
			try {
				setIsLoading(prev => ({...prev, daftarRuangan: true}))
				const { data: ruanganDataList } = await getRuanganDataList()
				setRuanganDataList(ruanganDataList.data)
			} finally {
				setIsLoading(prev => ({...prev, daftarRuangan: false}))
			}
		}
		if (checkPermission("ReadRuangan")) { 
			fetchData()
		}
  	}, [])

	
	useEffect(() => {
		setTitle("Daftar Ruangan Page")
	}, []);
return (
	<Layouts.ViewContainerLayout
		buttons={
			<>
			<Layouts.ViewContainerButtonLayout>
			  	{checkPermission("SaveRuangan") &&  (
			  	  <Link to={`/ruangan/tambah
			  	  `}>
			  	  	<Button id="_vhgAgCr6EfCz9KF7E6i0TQ" className="p-2" variant="primary">
			  	  	  Tambah Ruangan
			  	  	</Button>
			  	  </Link>
			  	  
			  	)}
			  	
			
			  </Layouts.ViewContainerButtonLayout>
			</>
		}
	>
{ checkPermission("ReadRuangan") && ( 
<Layouts.ListContainerTableLayout
	title={"Daftar Ruangan"}
	singularName={"Ruangan"}
	items={[ruanganDataList]}
	isLoading={isLoading.daftarRuangan}
>
	<RuanganTable
		ruanganDataList={ruanganDataList}
		
	/>
</Layouts.ListContainerTableLayout>
)}

	</Layouts.ViewContainerLayout>
  )
}
export default DaftarRuanganPage

